import AdminActionTypes from './admin.types'

export const setTeacher = (teacher) => ({
  type: AdminActionTypes.SET_TEACHER,
  payload: teacher,
})

export const setAllTeachers = (users) => ({
  type: AdminActionTypes.SET_ALL_USERS,
  payload: users,
})

export const updateSearchStatus = (user_id, is_searchable) => ({
  type: AdminActionTypes.UPDATE_SEARCH_STATUS,
  payload: { user_id, is_searchable },
})

export const updateTeacherLevel = (user_id, level) => ({
  type: AdminActionTypes.UPDATE_TEACHER_LEVEL,
  payload: { user_id, level },
})

export const updateCurrentCollegeDetails = (college) => ({
  type: AdminActionTypes.UPDATE_CURRENT_COLLEGE_DETAILS,
  payload: college,
})

// for AllCustomers page - lieh
export const setAllCustomers = (custs) => ({
  type: AdminActionTypes.SET_ALL_CUSTOMERS,
  payload: custs,
})
